var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitlecase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "titlecase"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.37616 13.4792L6.92458 6.65403C6.78313 6.26024 6.42703 6 6.02964 6C5.63395 6 5.279 6.25806 5.13637 6.64945L2.64746 13.4792M9.37616 13.4792L11 18M9.37616 13.4792H2.64746M1 18L2.64746 13.4792M23 8V17.5416C23 20.6119 20.845 23 17.5521 23C15.7603 23 14.138 22.2267 13 20.5892M22.9999 12.8933C22.9999 15.4699 21.0972 17.5587 18.75 17.5587C16.4028 17.5587 14.5 15.4699 14.5 12.8933C14.5 10.3168 16.4028 8.22803 18.75 8.22803C21.0972 8.22803 22.9999 10.3168 22.9999 12.8933Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitlecase);
export default __webpack_public_path__ + "static/media/titlecase.e8a6bb9789ee916c27ea45de96ac11bf.svg";
export { ForwardRef as ReactComponent };